import { LongWorkService } from "approot/global/providers/uikit.dialogs";
import { FixedEsiaRole } from "./services/login.service";
import { LoginStrategiesService } from "./services/login.strategies.service";
import { IdentityProvider } from "./login.repository";
import { getMobileAuthContext } from "./mobile.auth.context";

export interface EsiaPermissOptions {
	esiaPermissions?: boolean,
	esiaRole?: FixedEsiaRole
}

class SsoChooseRoleController {
	private DEFAULT_PROVIDER = IdentityProvider.Esia;

	public provider: IdentityProvider;
	public ready: boolean;
	public mobile: boolean;
	public mobileAccessToken: string;
	public isAuthorizing: boolean;
	public authorizingRole: FixedEsiaRole;
	public fixedEsiaRole = FixedEsiaRole;

	/*@ngInject*/
	constructor(
		private loginStrategiesService: LoginStrategiesService,
		private $longWork: LongWorkService,
		private $window: ng.IWindowService,
		public language
	) {
		let searchParams = new URLSearchParams(window.location.search);

		this.initAuthProvider(searchParams);

		const mobileContext = getMobileAuthContext(searchParams);
		this.mobile = mobileContext.has('mobile');
		if (this.mobile) {
			this.mobileAccessToken = mobileContext.get('access_token');
		}

		if (this.mobile && this.mobileAccessToken) {
			let asPromise = new Promise<void>((resolve) => { resolve(); })
				.then(() => { this.signAsParent(); });
			this.$longWork.execute(asPromise)
		}
		else {
			this.ready = true;
		}
	}

	private initAuthProvider(request: URLSearchParams) {
		let ret = parseInt(request.get('provider'));
		this.provider = ret > 0 ? ret : this.DEFAULT_PROVIDER;
	}

	goBack() {
		this.$window.history.back();
	}

	signAsParent() {
		this.signIn({ esiaPermissions: true, esiaRole: FixedEsiaRole.Parents });
	}

	signAsStudent() {
		this.signIn({ esiaPermissions: true, esiaRole: FixedEsiaRole.Students });
	}

	signAsStaff() {
		this.signIn({ esiaRole: FixedEsiaRole.AllStaffs });
	}

	private signIn(options: EsiaPermissOptions) {
		if (this.isAuthorizing) {
			return;
		}

		this.isAuthorizing = true;
		this.authorizingRole = options.esiaRole;
		this.loginStrategiesService.loginWithEsiaProviderPermissOptions(this.provider, options);
	}
}

export const SsoChooseRoleComponent = {
	controller: SsoChooseRoleController,
	controllerAs: "$ctrl",
	templateUrl: `/static/dist/app/login/sso-choose-role.component.html`
};
